export default __webpack_public_path__ + "1778f10.png";